import Vue from "vue";
import VueRouter from "vue-router";
import VueCookie from "../config/util.cookies";
import routes from "./routes";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);

const router = new VueRouter({
  // base: '/qrcode/',
  mode: "hash",
  routes
});
//路由跳转前进行权限验证
router.beforeEach((to, from, next) => {
  if (to.query.access_token) {
    VueCookie.set("access_token", to.query.access_token, {
      expires: "2h"
    });
  }
  const token = VueCookie.get("token");
  document.title = "海尔二维码管理平台";
  if (
    !token &&
    to.path !== "/login" &&
    to.path !== "/error" &&
    to.path !== "/ssoLogin"
  ) {
    next("/ssoLogin");
  } else {
    next();
  }
});
export default router;
